import {
  ChatRounded,
  CloseFullscreenRounded,
  OpenInFullOutlined,
} from '@mui/icons-material';
import { alpha, Box, Button, Typography } from '@mui/material';

interface AudioTranscriptButtonProps {
  onClick: () => void;
  isExpanded?: boolean;
}

export const AudioTranscriptButton = ({
  onClick,
  isExpanded,
}: AudioTranscriptButtonProps) => {
  return (
    <Box>
      <Button
        startIcon={
          <ChatRounded
            fontSize="small"
            sx={{
              color: 'feedback.label',
            }}
          />
        }
        endIcon={
          isExpanded ? (
            <CloseFullscreenRounded color="primary" fontSize="small" />
          ) : (
            <OpenInFullOutlined color="primary" fontSize="small" />
          )
        }
        onClick={onClick}
        sx={{
          backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.1),
          borderRadius: 1.5,
          height: 'fit-content',
          px: 2,
          py: 1,
        }}
        disabled={!isExpanded}
      >
        <Typography
          variant="body1"
          sx={{ textTransform: 'none' }}
          color="text.primary"
        >
          Transcript
        </Typography>
      </Button>
    </Box>
  );
};
